import React, {useState} from "react";
import { Popup } from "react-vant";
import { useLocation } from "react-router-dom";
import DepositPageBlock from "@/components/DepositPageBlock";
import HomeHeaderOther from "@/components/HomeHeader/indexOther";
import DepositHeader from "@/components/DepositHeader";
import style from "./style.less";
import DownloadFloatBall from "@/components/DownloadFloatBall";
import { FromInstalled } from "@/utils/BroswerHelper";
import { LanguageContext } from "@/data/LanguageProvider";

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}


const Deposit = () => {
  const query = useQuery();
  const backTo = query.get("back_to");

  const [backToUrl, setBackToUrl] = React.useState("");
  const [downloadFloatBall, setDownloadFloatBall] = React.useState(false);
  const { langText } = React.useContext(LanguageContext);
  const [showHelp, setShowHelp] = useState(false);

  React.useEffect(() => {
    //有backTo的时候，记住要跳转回去的页面
    if (backTo) {
      setBackToUrl(backTo);
    }
    //没有backTo的时候不管，防止注册登录互切的时候，backTo丢失
    console.log("backTo", backTo);
  }, [backTo]);

  React.useEffect(() => {
    //下载悬浮球
    if (!FromInstalled) {
      setDownloadFloatBall(true);
    }
  }, []);

  return (
    <div class={style.deposit_page_container}>
      <DepositHeader backToUrl={backToUrl} homeClick={() => setShowHelp(true)}/>
      <DepositPageBlock />
      <DownloadFloatBall floatBall={downloadFloatBall} onClose={()=>setDownloadFloatBall(false)} />
      <Popup
        visible={showHelp}
        className={style.helpPopup}
        closeable={true}
        onClose={() => setShowHelp(false)}
      >
        <div class={style.helpLabel}>
          <div style={{width:"100%", textAlign:"center", marginBottom:"2rem", fontWeight:"700", fontSize:"1.2rem"}}>
            {langText("deposit_tips_22")}
          </div>
          {/* <div class={style.depevebox_outer}> */}
            <div class={style.depevebox} style={{flexDirection: "column", justifyContent: "flex-start"}}>
              <p>
                {langText("deposit_tips_17")}
              </p>
              <p>
                {langText("deposit_tips_18")}
              </p>
              <p>
                {langText("deposit_tips_19")}
              </p>
              <p>
                {langText("deposit_tips_20")}
              </p>
              <p>
                {langText("deposit_tips_21")}
              </p>
            </div>
          {/* </div> */}
          {/* <div style={{position: "absolute", width:"100%", height:"10rem"}}>
            <img src={require("@/assets/images/home/deposit_tip.png").default} style={{ width: "100%" }} />
          </div> */}
        </div>
      </Popup>
    </div>
  );
};

export default Deposit;
